/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Feat2_TitleInputs */

const es_exp_mk_feat2_title = /** @type {(inputs: Exp_Mk_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva tu plaza`)
};

const gl_exp_mk_feat2_title = /** @type {(inputs: Exp_Mk_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva a túa praza`)
};

const en_exp_mk_feat2_title = /** @type {(inputs: Exp_Mk_Feat2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book your place`)
};

/**
* | output |
* | --- |
* | "Book your place" |
*
* @param {Exp_Mk_Feat2_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_feat2_title = /** @type {((inputs?: Exp_Mk_Feat2_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Feat2_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_feat2_title(inputs)
	if (locale === "en") return en_exp_mk_feat2_title(inputs)
	return es_exp_mk_feat2_title(inputs)
});